<script lang="ts">
    import { hostViewportHeight } from '$lib/Stores/stores';
    import { cn } from '$lib/utils/cn';

    import Close from './Close.svelte';
    import DE from './DE.svelte';
    import EN from './EN.svelte';

    import type { Language } from '$lib/types/Language';

    export let language: Language = 'en';
    export let acceptCookies = (integrations: Record<string, boolean>) => {
        console.warn('No acceptCookies function provided', integrations);
    };
    export let integrationsToShow: string[] = [];

    let verticalOffsetStyle: string;
    let element: HTMLDivElement;

    const integrationsToEnable: Record<string, boolean> = {};

    integrationsToShow.forEach((integration: string) => {
        integrationsToEnable[integration] = true;
    });

    const handleAcceptClick = () => {
        acceptCookies(integrationsToEnable);
    };

    $: {
        if (element) {
            verticalOffsetStyle =
                $hostViewportHeight > 0
                    ? `top: ${$hostViewportHeight - element.scrollHeight - 20}px;`
                    : '';
        }
    }
</script>

<div
    class={cn(
        'fun-w-[calc(100% - 16px)] fun-flex fun-min-h-[64px] fun-items-start fun-rounded-lg fun-bg-gray-50 fun-p-5 fun-px-6 fun-font-sans fun-shadow-lg sm:fun-w-[360px]',
        {
            'fun-absolute fun-bottom-auto': $hostViewportHeight > 0,
        },
    )}
    style={verticalOffsetStyle}
    bind:this={element}
    role="dialog"
    aria-modal="true"
    aria-label={language === 'de' ? 'Hinweis zur Datenverarbeitung' : 'Cookie notice'}
    tabindex="-1"
>
    {#if language === 'de'}
        <DE onLinkClick={handleAcceptClick} />
    {:else}
        <EN onLinkClick={handleAcceptClick} />
    {/if}

    <button
        class="fun-flex-1 fun-text-lg fun-text-gray-400 hover:fun-text-gray-900"
        on:click={handleAcceptClick}
        aria-label={language === 'de' ? 'Cookies akzeptieren' : 'Accept cookies'}
    >
        <Close />
    </button>
</div>
